<a class="learning-path">
  <div
    class="learning-path-image"
    [placeholderImage]="!item()?.mediaImage && item()?.bundle"
    [cropImage]="item()?.mediaImage | preSignedUrl | async"
    [crop]="item()?.mediaImage?.crop">
  </div>

  <div class="learning-path-body">
    <div class="learning-path-info">

      <div class="learning-path-bundle">
        <span class="path-bundle">{{ 'LEARNING_PATH.learning_path' | translate }}</span>

        @if (item()?.deadline) {
          <div class="path-deadline" [class.overdue]="item()?.overdue">
            @if (!item()?.overdue) {
              {{ 'LEARNING_PATH.complete_path_till' | translate }}
              {{ item()?.deadline | customDate : 'shortDate' }}
            } @else {
              {{ 'LEARNING_PATH.past_deadline' | translate : { date: item()?.deadline | customDate } }}
            }
          </div>
        }

        @if (item()?.locked && item()?.progress !== 100) {
          <div class="path-locked">
            <lib-icon icon="lock-simple" [size]="16"></lib-icon>
            {{ 'MODULE_LESSON_CARD.locked' | translate }}
          </div>
        }
      </div>

      <div class="learning-path-title">
        {{ item()?.title }}
      </div>

      <div class="learning-path-details">
        @if (item()?.progress && item()?.progress !== 100 && cardsSettings?.learning_path?.progress?.visible) {
          <div class="progress-wrapper" [style.order]="cardsSettings?.learning_path?.progress?.weight">
            <mat-progress-bar class="default-theme" aria-label="Progress" mode="determinate" [value]="item().progress"></mat-progress-bar> {{item().progress}}%
          </div>
        }
        @if (item()?.progress === 100) {
          <div class="path-completed">
            <lib-icon icon="check-circle" [fill]="true" [size]="16"></lib-icon> {{'MODULE_LESSON_CARD.completed' | translate}}
          </div>
        }
        @if (cardsSettings?.learning_path?.steps?.visible) {
          <span class="lessons-count" [style.order]="cardsSettings?.learning_path?.steps?.weight">
            <lib-icon icon="stack" [size]="16"></lib-icon>
            {{item()?.stepsCompleted}}/{{item()?.stepsCount}} {{'COMMON.steps' | translate}}
          </span>
        }

        @if (item()?.totalTime && cardsSettings?.learning_path?.time?.visible) {
          <span class="time-count" [style.order]="cardsSettings?.learning_path?.time?.weight">
            <lib-icon icon="clock" [size]="16"></lib-icon>
            {{item()?.totalTime | minutesToTime : 'short' }}
          </span>
        }

        @if (item()?.leaderboardPoints && leaderboardEnabled && cardsSettings?.learning_path?.leaderboardPoints?.visible) {
          <div [style.order]="cardsSettings?.learning_path?.leaderboardPoints?.weight" [matTooltip]="'COMMON.content_complete_points' | translate:{points: item()?.leaderboardPoints}" class="content-card__body--label-item">
            <lib-icon icon="currency-eth" [size]="16"></lib-icon> {{item()?.leaderboardPoints}} {{'LEADERBOARD.pts' | translate | lowercase}}
          </div>
        }
        @if (item()?.badge && achievementsEnabled && cardsSettings?.learning_path?.achievements?.visible) {
          <div [style.order]="cardsSettings?.learning_path?.achievements?.weight" [matTooltip]="'COMMON.content_complete_achievements' | translate:{count: 1, content: item()?.badge?.title}" class="content-card__body--label-item">
            <lib-icon icon="medal" [size]="16"></lib-icon> {{'COMMON.achievement' | translate}}
          </div>
        }
        @if (item()?.customCertificate && certificatesEnabled && cardsSettings?.learning_path?.certificate?.visible) {
          <div [style.order]="cardsSettings?.learning_path?.certificate?.weight" [matTooltip]="'COMMON.content_complete_certificate' | translate:{ certificate: item()?.customCertificate?.title }" class="content-card__body--label-item">
            <lib-icon icon="certificate" [size]="16"></lib-icon> {{'COMMON.certificate' | translate}}
          </div>
        }
      </div>

    </div>
    <div class="learning-path-buttons">
      <button mat-flat-button class="button button--primary-outline button--primary-text button--large see-details-button">
        {{'COMMON.see_details' | translate}}
      </button>

      @if (item()?.progress !== 100) {
        <button
          mat-flat-button
          class="button button--primary button--large start-button"
          [disabled]="item()?.locked"
          (click)="start($event)">
          @if (startButtonLoading() | async) {
            <mat-spinner color="white" [diameter]="20"></mat-spinner>
          }
          {{(item()?.progress === 0 ? 'LEARNING_PATH.start_path' : 'LEARNING_PATH.continue_path') | translate }}
        </button>
      }
    </div>
  </div>

</a>
